import {
    ChangeDetectorRef,
    Component,
    Inject,
    OnInit,
    ViewEncapsulation,
} from "@angular/core";
import {
    AbstractControl,
    FormArray,
    FormBuilder,
    FormControl,
    FormGroup,
    Validators,
} from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { TranslateService } from "@ngx-translate/core";
import * as _ from "lodash";
import * as moment from "moment";
import { CustomValidators } from "@rizwan3d/ngx-custom-validators-16";
import * as toastr from "toastr";
import { AuthenticationService } from "../../../../../../services/security/authentication.service";
import { RecordAction } from "../../../../../../utils/enums/shared/enums";
import { ShortCode } from "../../../../../../utils/types/shared/shortcode.type";
import { ShortCodesKeyword } from "../../../../../../utils/types/shared/shortcodeskeyword";
import { SharedCatalogService } from "../../../../../../services/shared/sharedcatalog.service";
import { Grupo } from "../../../../../../utils/types/groups/grupo.type";
import { GruposService } from "../../../../../../services/groups/grupos.service";
import {
    BrowserAction,
    ContentSAT,
    InputAction,
    SmsAction,
} from "../../../../../../utils/types/sat/contentSAT.type";
import { SatDTO } from "../../../../../../utils/types/sat/satDTO.type";
import { SatService } from "../../../../../../services/sat/sat.service";

@Component({
    selector: "wtf-sat-programado-form",
    templateUrl: "./sat-programado-form.component.html",
    styleUrls: ["./sat-programado-form.component.scss"],
    providers: [
        SatService,
        AuthenticationService,
        SharedCatalogService,
        GruposService,
    ],
    encapsulation: ViewEncapsulation.None,
})
export class SatProgramadoFormComponent implements OnInit {
    satModel: SatDTO;
    dialogTitle: string;
    action: RecordAction;
    callback: (sat) => void;

    firstFormGroup: FormGroup;
    secondFormGroup: FormGroup;
    thirdFormGroup: FormGroup;

    itemsSAT: FormArray;
    contentsSAT: Array<ContentSAT>;

    recurrenceDays: String[];
    esRecurrente = false;

    shortCodes: ShortCode[];
    grupos: Grupo[];
    operators: any;
    // presetColors = MatColors.presets;
    recordAction = RecordAction;

    disabledDiasEspecificos = true;
    resetSelection = false;
    checkedRadioButon: number;
    checkedRadioButton = new Array<number>();
    selectedKeyword = new Array<number>();
    selectedParaShortCode = new Array<number>();
    isWaiting = false;
    shortCodesKeywords: ShortCodesKeyword[];
    counter = 1;

    tabs = ["Sat-1"];
    selected = new FormControl(0);

    acciones = [
        { id: 1, name: "Sin Acciones" },
        { id: 2, name: "Enviar SMS" },
        { id: 3, name: "Abrir Navegador" },
        { id: 4, name: "SAT Input" },
    ];

    shortCodes_abanico = [{ id: 1, value: "9292" }];

    constructor(
        public dialogRef: MatDialogRef<SatProgramadoFormComponent>,
        private ref: ChangeDetectorRef,
        @Inject(MAT_DIALOG_DATA) private data: any,
        private gruposervice: GruposService,
        private sharedCatalog: SharedCatalogService,
        private _formBuilder: FormBuilder,
        private translateService: TranslateService
    ) {
        this.satModel = data.sat;
        this.action = data.action;
        this.shortCodes = data.shortCodes;
        this.callback = data.callback;
        this.checkedRadioButton.push(1);
        this.acciones.forEach((element) => {
            element.name = this.translateService.instant(element.name);
        });
        this.contentsSAT = new Array<ContentSAT>();

        if (
            this.action === RecordAction.Update ||
            this.action === RecordAction.View
        ) {
            this.dialogTitle = "Campaña SAT Programada";
            this.dialogTitle = this.translateService.instant(this.dialogTitle);
            // this.dialogTitle = this.satModel.name;
            this.gruposervice
                .getGroupByOperator(
                    this.satModel.shortCode.operatorId
                        ? this.satModel.shortCode.operatorId
                        : this.satModel.shortCode.operator_id
                )
                .subscribe((res) => {
                    this.grupos = res;
                    this.firstFormGroup.controls["grupo"].setValue(
                        this.satModel.groups
                    );
                });
        } else {
            this.dialogTitle = "Programar Envio de Campaña SAT";
            this.dialogTitle = this.translateService.instant(this.dialogTitle);
            this.satModel = new SatDTO();
        }

        switch (this.satModel.recurrence_mode) {
            case "1111111":
                this.checkedRadioButon = 1;
                this.resetSelection = true;
                break;
            case "0111110":
                this.checkedRadioButon = 2;
                this.resetSelection = true;
                break;

            default:
                this.checkedRadioButon = 3;
                this.disabledDiasEspecificos = false;
                break;
        }

        this.recurrenceDays = this.satModel.recurrence_mode.split("");

        if (
            moment(this.satModel.execute_date, "YYYY-MM-DD").toDate() <
            moment(this.satModel.execute_end_date, "YYYY-MM-DD").toDate()
        ) {
            this.esRecurrente = true;
        }

        this.firstFormGroup = this._formBuilder.group({
            name: [this.satModel.name, Validators.required],
            istracking: [this.satModel.istracking],
            shortcode: [this.satModel.shortCode, Validators.required],
            grupo: [this.satModel.groups, Validators.required],
        });

        this.firstFormGroup.controls["name"].valueChanges.subscribe(
            (value) => (this.satModel.name = value)
        );

        this.firstFormGroup.controls["istracking"].valueChanges.subscribe(
            (value) => (this.satModel.istracking = value)
        );

        this.firstFormGroup.controls["shortcode"].valueChanges.subscribe(
            (value) => {
                this.satModel.shortCode = value;
                this.satModel.operator_id = this.satModel.shortCode.operatorId
                    ? this.satModel.shortCode.operatorId
                    : this.satModel.shortCode.operator_id;
                this.satModel.operatorId = this.satModel.shortCode.operatorId
                    ? this.satModel.shortCode.operatorId
                    : this.satModel.shortCode.operator_id;
                this.satModel.organization_short_code_id =
                    this.satModel.shortCode.id;
                this.satModel.type = this.satModel.shortCode.type;

                this.gruposervice
                    .getGroupByOperator(
                        this.satModel.shortCode.operatorId
                            ? this.satModel.shortCode.operatorId
                            : this.satModel.shortCode.operator_id
                    )
                    .subscribe((res) => {
                        this.grupos = res;
                        this.firstFormGroup.controls["grupo"].setValue(
                            this.satModel.groups
                        );
                    });
            }
        );

        this.firstFormGroup.controls["grupo"].valueChanges.subscribe(
            (value) => {
                this.satModel.groups = value;
            }
        );

        this.secondFormGroup = this._formBuilder.group({
            items: this._formBuilder.array([this.createItemSAT()]),
        });

        this.itemsSAT = this.secondFormGroup.get("items") as FormArray;
        this.itemsSAT.at(0).get("message").setValidators(Validators.required);

        this.thirdFormGroup = this._formBuilder.group({
            esRecurrente: [this.esRecurrente],
            esActivo: [Boolean(this.satModel.status.id)],
            fechaInicio: [
                moment(this.satModel.execute_date, "YYYY-MM-DD").toDate(),
                [
                    Validators.required,
                    CustomValidators.minDate(moment(new Date(), "YYYY-MM-DD")),
                ],
            ],
            fechaFin: [
                moment(this.satModel.execute_end_date, "YYYY-MM-DD").toDate(),
            ],
            time: [this.satModel.execute_time],

            lunes: [Boolean(Number(this.recurrenceDays[1]))],
            martes: [Boolean(Number(this.recurrenceDays[2]))],
            miercoles: [Boolean(Number(this.recurrenceDays[3]))],
            jueves: [Boolean(Number(this.recurrenceDays[4]))],
            viernes: [Boolean(Number(this.recurrenceDays[5]))],
            sabado: [Boolean(Number(this.recurrenceDays[6]))],
            domingo: [Boolean(Number(this.recurrenceDays[0]))],
        });

        this.thirdFormGroup.controls["esRecurrente"].valueChanges.subscribe(
            (value) => {
                this.esRecurrente = value;
                // tslint:disable-next-line:prefer-const

                if (this.esRecurrente === false) {
                    const changeEvent: any = { value: 1 };
                    this.radioChangeRecurrent(changeEvent);
                }
            }
        );

        this.thirdFormGroup.controls["esActivo"].valueChanges.subscribe(
            (value) => {
                this.satModel.statusId = Number(value);
                this.satModel.status.id = Number(value);
                value
                    ? (this.satModel.status.name = "Activo")
                    : (this.satModel.status.name = "Inactivo");
            }
        );

        this.thirdFormGroup.controls["fechaInicio"].valueChanges.subscribe(
            (value) => (this.satModel.execute_date = value)
        );
        this.thirdFormGroup.controls["fechaFin"].valueChanges.subscribe(
            (value) => (this.satModel.execute_end_date = value)
        );
        this.thirdFormGroup.controls["time"].valueChanges.subscribe((value) => {
            this.satModel.execute_time = value;
        });

        this.thirdFormGroup.controls["lunes"].valueChanges.subscribe(
            (value) => (this.recurrenceDays[1] = Number(value).toString())
        );
        this.thirdFormGroup.controls["martes"].valueChanges.subscribe(
            (value) => (this.recurrenceDays[2] = Number(value).toString())
        );
        this.thirdFormGroup.controls["miercoles"].valueChanges.subscribe(
            (value) => (this.recurrenceDays[3] = Number(value).toString())
        );
        this.thirdFormGroup.controls["jueves"].valueChanges.subscribe(
            (value) => (this.recurrenceDays[4] = Number(value).toString())
        );
        this.thirdFormGroup.controls["viernes"].valueChanges.subscribe(
            (value) => (this.recurrenceDays[5] = Number(value).toString())
        );
        this.thirdFormGroup.controls["sabado"].valueChanges.subscribe(
            (value) => (this.recurrenceDays[6] = Number(value).toString())
        );
        this.thirdFormGroup.controls["domingo"].valueChanges.subscribe(
            (value) => (this.recurrenceDays[0] = Number(value).toString())
        );
    }

    createItemSAT(): FormGroup {
        return this._formBuilder.group({
            message: [""],
            para: [
                { value: "", disabled: this.action === this.recordAction.View },
            ],
            contenido: [
                { value: "", disabled: this.action === this.recordAction.View },
            ],
            textoamostrar: [""],
            url: [""],
            min: [""],
            max: [""],
            para2: [
                { value: "", disabled: this.action === this.recordAction.View },
            ],
        });
    }

    ngOnInit() {
        /*   this.sharedCatalog.gethortcodesAndKeyword().subscribe(res => {
               this.shortCodesKeywords = res;
           }); */

        if (this.action !== RecordAction.Add) {
            this.postValuesInArrayForm();
        }
    }

    compareFn(op1: any, op2: any) {
        return op1.id === op2.id;
    }

    performAction() {
        if (!this.esRecurrente) {
            this.satModel.execute_end_date = moment(
                moment(this.satModel.execute_date, "YYYY-MM-DD")
                    .add(1, "days")
                    .subtract(1, "seconds"),
                "YYYY-MM-DD HH:mm:ss"
            ).toString();
        } else {
            this.satModel.recurrence_mode = this.recurrenceDays.join("");
        }

        if (!this.isValidContactHour(this.satModel.execute_time)) {
            toastr.warning(
                this.translateService.instant(
                    "La hora de ejecucion de la campaña debe ser entre las 8:00 y las 18:00"
                ),
                "Sat"
            );
            return;
        }

        if (
            this.firstFormGroup.invalid ||
            this.secondFormGroup.invalid ||
            this.thirdFormGroup.invalid
        ) {
            return;
        }

        this.isWaiting = true;

        const arrayControl = this.secondFormGroup.get("items") as FormArray;

        for (let i = 0; i < arrayControl.controls.length; i++) {
            const itemSat = new ContentSAT();
            const control = arrayControl.at(i);

            if (control.invalid) {
                return;
            }

            itemSat.order = i + 1;
            itemSat.message = control.get("message").value;

            if (this.checkedRadioButton[i] === 2) {
                const smsAction = new SmsAction();
                smsAction.content = control.get("contenido").value;
                smsAction.to = control.get("para").value;
                itemSat.smsAction = smsAction;
            }

            if (this.checkedRadioButton[i] === 3) {
                const browserAction = new BrowserAction();
                browserAction.loadingText = control.get("textoamostrar").value;
                browserAction.url = control.get("url").value;
                itemSat.browserAction = browserAction;
            }

            if (this.checkedRadioButton[i] === 4) {
                const inputAction = new InputAction();
                inputAction.min = control.get("min").value;
                inputAction.max = control.get("max").value;
                inputAction.short_code = control.get("para2").value;
                itemSat.inputAction = inputAction;
            }

            this.contentsSAT.push(itemSat);
        }

        this.satModel.contents = this.contentsSAT;

        this.callback(this.satModel);
    }

    addTab() {
        this.counter = this.counter + 1;
        const name = "Sat-" + this.counter;
        this.tabs.push(name);

        this.checkedRadioButton.push(1);

        this.itemsSAT = this.secondFormGroup.get("items") as FormArray;
        this.itemsSAT.push(this.createItemSAT());
        this.ref.detectChanges();
        this.selected.setValue(this.tabs.length - 1);
    }

    removeTab(index: number) {
        this.itemsSAT = this.secondFormGroup.get("items") as FormArray;

        if (this.tabs.length !== 1) {
            this.tabs.splice(index, 1);
            this.itemsSAT.controls.splice(index, 1);
        }
    }

    radioChange(event: any, index: number) {
        const reg = "(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?";
        const arrayControl = this.secondFormGroup.get("items") as FormArray;
        const control = arrayControl.at(index);

        switch (event.value) {
            case 4:
                control.get("max").setValidators(Validators.required);
                control.get("min").setValidators([Validators.required]);
                control.get("para2").setValidators([Validators.required]);
                this.ref.detectChanges();

                this.clearControlValidator(control, "contenido");
                this.clearControlValidator(control, "para");
                this.clearControlValidator(control, "textoamostrar");
                this.clearControlValidator(control, "url");
                this.ref.detectChanges();

                break;

            case 3:
                control.get("textoamostrar").setValidators(Validators.required);
                control.get("textoamostrar").updateValueAndValidity();
                control
                    .get("url")
                    .setValidators([
                        Validators.required,
                        Validators.pattern(reg),
                    ]);
                control.get("url").updateValueAndValidity();
                this.ref.detectChanges();
                this.clearControlValidator(control, "contenido");
                this.clearControlValidator(control, "para");
                this.clearControlValidator(control, "max");
                this.clearControlValidator(control, "min");
                this.clearControlValidator(control, "para2");
                this.ref.detectChanges();

                break;
            case 2:
                control.get("contenido").setValidators(Validators.required);
                control.get("para").setValidators(Validators.required);
                this.ref.detectChanges();

                this.clearControlValidator(control, "textoamostrar");
                this.clearControlValidator(control, "url");
                this.clearControlValidator(control, "max");
                this.clearControlValidator(control, "min");
                this.clearControlValidator(control, "para2");
                this.ref.detectChanges();

                break;
            default:
                this.clearControlValidator(control, "contenido");
                this.clearControlValidator(control, "para");
                this.clearControlValidator(control, "textoamostrar");
                this.clearControlValidator(control, "url");
                this.clearControlValidator(control, "max");
                this.clearControlValidator(control, "min");
                this.clearControlValidator(control, "para2");
                this.ref.detectChanges();

                break;
        }
    }

    clearControlValidator(control: AbstractControl, controlName: string) {
        control.get(controlName).clearValidators();
        control.get(controlName).updateValueAndValidity();
    }

    radioChangeRecurrent(event: any) {
        switch (event.value) {
            case "3":
                this.disabledDiasEspecificos = false;
                this.checkedRadioButon = 3;
                if (this.resetSelection === true) {
                    this.thirdFormGroup.controls["lunes"].setValue(false);
                    this.thirdFormGroup.controls["martes"].setValue(false);
                    this.thirdFormGroup.controls["miercoles"].setValue(false);
                    this.thirdFormGroup.controls["jueves"].setValue(false);
                    this.thirdFormGroup.controls["viernes"].setValue(false);
                    this.thirdFormGroup.controls["sabado"].setValue(false);
                    this.thirdFormGroup.controls["domingo"].setValue(false);
                }
                break;

            default:
                this.disabledDiasEspecificos = true;
                this.satModel.recurrence_mode = "1111111";
                this.recurrenceDays = this.satModel.recurrence_mode.split("");
                this.checkedRadioButon = 1;
                break;
        }
    }

    postValuesInArrayForm() {
        const arrayControl = this.secondFormGroup.get("items") as FormArray;
        this.satModel.contents = _.orderBy(
            this.satModel.contents,
            ["order"],
            ["asc"]
        );

        let formField: AbstractControl;

        for (let i = 0; i < this.satModel.contents.length; i++) {
            if (i >= 1) {
                this.addTab();
            }

            const control = arrayControl.at(i);

            formField = control.get("message");
            formField.setValue(this.satModel.contents[i].message);

            if (this.satModel.contents[i].smsAction) {
                this.checkedRadioButton[i] = 2;

                formField = control.get("contenido");
                formField.setValue(this.satModel.contents[i].smsAction.content);

                formField = control.get("para");
                formField.setValue(this.satModel.contents[i].smsAction.to);
            }

            if (this.satModel.contents[i].browserAction) {
                this.checkedRadioButton[i] = 3;

                formField = control.get("textoamostrar");
                formField.setValue(
                    this.satModel.contents[i].browserAction.loadingText
                );

                formField = control.get("url");
                formField.setValue(this.satModel.contents[i].browserAction.url);
            }

            if (this.satModel.contents[i].inputAction) {
                this.checkedRadioButton[i] = 4;

                formField = control.get("min");
                formField.setValue(this.satModel.contents[i].inputAction.min);

                formField = control.get("max");
                formField.setValue(this.satModel.contents[i].inputAction.max);

                formField = control.get("para2");
                formField.setValue(
                    this.satModel.contents[i].inputAction.short_code
                );
            }
        }
        this.selected.setValue(0);
    }

    esRecurrenteChecked(event: any) {}

    isValidContactHour(value: string) {
        if (value) {
            const workingHour = value.split(":");
            const HH = workingHour[0];
            const mm = workingHour[1];

            if (Number(HH) >= 8 && Number(HH) <= 18) {
                return true;
            }
        }

        return false;
    }
}
